<div *ngIf="!importCompleted">
    <h4>
        {{ importInProgress ? 'Importing Data' : 'Import Completed' }}
    </h4>
    <div class="progress-section">
        <div class="progress-bar">
            <div class="progress" [ngStyle]="{ width: importProgress + '%' }"></div>
        </div>
        <p>{{ importProgress }}% Completed</p>
    </div>
</div>

<!-- When importCompleted show either errors (if any) OR the imported rows preview -->
<div *ngIf="importCompleted">
    <div class="import-summary">
        <ng-container *ngIf="!loadingTotals">
            <h4>Review Imported Claim Data</h4>
            <!-- Show Error Section Toggle Button -->
            <div *ngIf="importErrors && importErrors.length !== 0" style="margin-bottom: 16px;">
                <button (click)="toggleError()" class="button-small">
                    {{ showErrors ? 'Hide Sample Errors' : 'Show Sample Errors' }}
                </button>
            </div>
            <!-- Show Error Section -->
            <ng-container *ngIf="showErrors">
                <div *ngIf="showErrors" class="import-errors">
                    <h3 class="error-header pt-2">Import Batch Errors</h3>
                    <p class="error-subheading" style="font-size: 14px; color: #666; margin-top: 5px; margin-bottom: 15px;">
                        <ng-container *ngIf="errorRowCount > 0">
                            {{ errorRowCount }} {{ errorRowCount === 1 ? 'row' : 'rows' }} contained errors while importing the batch.
                        </ng-container>
                        <ng-container *ngIf="errorRowCount === 0 && filteredErrors.length > 0">
                            Errors occurred during import.
                        </ng-container>
                        See {{ filteredErrors.length }} {{ filteredErrors.length === 1 ? 'sample' : 'samples' }} below.
                    </p>
                    <div class="totals">
                        <p>Some errors occured while importing the batch. See details below.</p>
                    </div>
                    <table class="error-details-table">
                        <thead>
                            <tr>
                                <th>Row</th>
                                <th>Column</th>
                                <th>Value</th>
                                <th>Message</th>
                                <th>Attempted Format</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let err of filteredErrors">
                                <td>{{ err.row }}</td>
                                <td>{{ err.column }}</td>
                                <td>{{ formatErrorValue(err.value) }}</td>
                                <td>{{ err.message }}</td>
                                <td>{{ err.attemptedFormats || err.expectedType }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <button (click)="deleteClaimBatch()" class="button-small">
                        Delete and Retry Claim Batch Import
                    </button>
                </div>
            </ng-container>

            <!-- Combined Import Statistics and Summary -->
            <div class="import-statistics" style="margin-top: 30px; margin-bottom: 20px;">
                <h4>Import Statistics</h4>
                <table class="summary-details-table" style="margin-top: 10px;">
                    <tbody>
                        <tr>
                            <th>Rows Marked for Import:</th>
                            <td><strong>{{ formatNumber(totalRows) }}</strong></td>
                        </tr>
                        <tr>
                            <th>Rows Imported Successfully:</th>
                            <td style="color: #28a745;"><strong>{{ formatNumber(rowsImported) }}</strong></td>
                        </tr>
                        <tr>
                            <th>Rows Failed:</th>
                            <td style="color: #dc3545;"><strong>{{ formatNumber(errorRowCount > 0 ? errorRowCount : (totalRows - rowsImported)) }}</strong></td>
                        </tr>
                        <tr>
                            <th>Total Rows Imported:</th>
                            <td><strong>{{ formatNumber(totals.totalRowsImported) }}</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>
    </div>

    <div class="review-import-data">
        <div class="import-preview">
            <!-- Show Data Section -->
            <ng-container>
                <button (click)="toggleSampleData()">
                    {{ showData ? 'Hide Imported Rows' : 'Show Imported Rows' }}
                </button>
                <div *ngIf="loading" class="loading-indicator" style="padding-top: 10px;">
                    <div class="spinner"></div>
                    Loading data, please wait...
                </div>
                <div *ngIf="showData && !loading">
                    <div *ngIf="sampleRows.length === 0" class="no-data">
                        No sample data available for this claims batch.
                    </div>
                    <div class="data-preview-container" *ngIf="sampleRows.length > 0">
                        <table class="data-preview-table">
                            <thead>
                                <tr>
                                    <th>Policy Number</th>
                                    <th>Claim Number</th>
                                    <th>Debtor Name</th>
                                    <th>Date Claim Received</th>
                                    <th>Status</th>
                                    <th>Gross Claim Amount</th>
                                    <th>Cause Of Loss</th>
                                    <th>Date Due For Payment</th>
                                    <th>Date Paid</th>
                                    <th>Indemnity Amount</th>
                                    <th>Total Legal Fees</th>
                                    <th>Total Salvages</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of sampleRows">
                                    <td>{{ row.policyNumber || '-' }}</td>
                                    <td>{{ row.claimNumber || '-' }}</td>
                                    <td>{{ row.debtorName || '-' }}</td>
                                    <td>{{ formatDate(row.dateClaimReceived) }}</td>
                                    <td>{{ row.status || '-' }}</td>
                                    <td>{{ formatCurrency(row.grossClaimAmount) }}</td>
                                    <td>{{ row.causeOfLoss || '-' }}</td>
                                    <td>{{ formatDate(row.dateDueForPayment) }}</td>
                                    <td>{{ formatDate(row.datePaid) }}</td>
                                    <td>{{ formatCurrency(row.indemnityAmount) }}</td>
                                    <td>{{ formatCurrency(row.totalLegalFees) }}</td>
                                    <td>{{ formatCurrency(row.totalSalvages) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>